export const config = {
	name: 'Feedbask',
	description: 'Embeddable widget for customer satisfaction',
	appName: 'Feedbask',
	domainName: 'feedbask.com',
	companyName: 'Upopy SARL',
	companyAddress: '205 avenue Charles de Gaulle, 92200 Neuilly-sur-Seine',
	companySiret: '950 997 221 00011',
	companyRcs: '950 997 221 R.C.S. Nanterre',
	companyShareCapital: '2 000 €',
	companyVatNumber: 'FR30950997221',
	publicationDirector: 'Pauline Clavelloux',
	// affiliateProgramUrl:"",
	supportEmail: 'contact@feedbask.com',
	websiteUrl: 'https://feedbask.com',
	paymentProvider: 'Stripe',
	privacyPolicyUrl: 'https://feedbask.com/privacy',
	termsAndConditionsUrl: 'https://feedbask.com/tos',
	legalNoticeUrl: 'https://feedbask.com/legal',
	cookiePolicyUrl: 'https://feedbask.com/cookies',
	logo: '/images/logo_feedbask.png',
	apiUrl: 'auto', // Will be resolved dynamically by getApiBaseUrl()
}

export default config
